export type AudioUtil = HTMLAudioElement & {
  setSinkId(deviceId: string): Promise<undefined>;
};

/**
 * `AudioContext.setSinkId` doesn't like `undefined or `'default'` being used as an argument. This method
 * takes those values and converts them to the expected default value of an empty string. For all other values,
 * the original value is returned.
 */
export const sanitizeAudioContextSinkId = (deviceId: string | undefined): string => {
  return !deviceId || deviceId === 'default' ? '' : deviceId;
};
